function e(r, n) {
  return function(t) {
    return r(n(t));
  };
}
export {
  e as default
};
